import { useSignal } from "@preact/signals";
import { useEffect } from "preact/hooks";
import { lt, t } from "@/i18n";
import { advanceDialog, closeDialog, dialog, pickChoice } from "@/state/store";

export function DialogBox() {
  const d = dialog.value;
  const selected = useSignal(0);

  useEffect(() => {
    selected.value = 0;
  }, [d?.openedAt]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const cur = dialog.value;
      if (!cur) return;
      if (performance.now() - cur.openedAt < 200) return; // ignore the key press that opened the dialog
      const choices = cur.choices;
      if (choices && cur.index + 1 >= cur.lines.length) {
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          e.preventDefault();
          selected.value = (selected.value + choices.length - 1) % choices.length;
        } else if (e.key === "ArrowRight" || e.key === "ArrowDown") {
          e.preventDefault();
          selected.value = (selected.value + 1) % choices.length;
        } else if (e.key === "Enter" || e.key === " " || e.key.toLowerCase() === "e") {
          e.preventDefault();
          pickChoice(selected.value);
        } else if (/^[1-9]$/.test(e.key) && Number(e.key) <= choices.length) {
          pickChoice(Number(e.key) - 1);
        } else if (e.key === "Escape") {
          closeDialog();
        }
        return;
      }
      if (e.key === " " || e.key === "Enter" || e.key.toLowerCase() === "e") {
        e.preventDefault();
        advanceDialog();
      } else if (e.key === "Escape") {
        closeDialog();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  if (!d) return null;
  const line = d.lines[d.index];
  const last = d.index + 1 >= d.lines.length;
  const showChoices = last && d.choices;
  return (
    <div class={`dialog ${d.faceset ? "with-face" : ""}`} onClick={() => !showChoices && advanceDialog()}>
      {d.faceset && <img class="faceset" src={d.faceset} alt="" />}
      <div class="dialog-body">
        <div class="speaker">{lt(d.speaker)}</div>
        <div class="line">{line ? lt(line) : ""}</div>
        {showChoices ? (
          <div class="dialog-choices">
            {d.choices!.map((c, i) => (
              <button
                key={i}
                class={i === selected.value ? "selected primary" : ""}
                onClick={() => pickChoice(i)}
              >
                <kbd>{i + 1}</kbd> {lt(c.label)}
              </button>
            ))}
          </div>
        ) : (
          <div class="next">
            {last ? t("dialog.close") : t("dialog.next")} ▸ {d.index + 1}/{d.lines.length}
          </div>
        )}
      </div>
    </div>
  );
}
